import * as React from 'react';

import { useChangeSitePlanDialog } from './useChangeSitePlanDialog';
import { useSiteUpgradeModal } from './useSiteUpgradeModal';

// Lazy-loaded: only mounted once their cheap open-state hook reports the modal has been opened,
// so the billing/plan chunks are fetched on first use instead of at boot.
const SiteUpgradeModal = React.lazy(() =>
    import('./SiteUpgradeModal').then((m) => ({
        default: m.SiteUpgradeModal,
    }))
);
const ChangeSitePlanDialog = React.lazy(() =>
    import('./ChangeSitePlanDialog').then((m) => ({
        default: m.ChangeSitePlanDialog,
    }))
);

/**
 * Mounts site plan dialogs lazily to keep the plan UI out of the eager app boot graph.
 */
export function SitePlanDialogs() {
    return (
        <>
            <SiteUpgradeModalGate />
            <ChangeSitePlanDialogGate />
        </>
    );
}

function SiteUpgradeModalGate() {
    const { isOpened } = useSiteUpgradeModal();
    const hasOpened = React.useRef(false);
    hasOpened.current = hasOpened.current || isOpened;
    if (!hasOpened.current) {
        return null;
    }
    return (
        <React.Suspense fallback={null}>
            <SiteUpgradeModal />
        </React.Suspense>
    );
}

function ChangeSitePlanDialogGate() {
    const { site } = useChangeSitePlanDialog();
    const hasOpened = React.useRef(false);
    hasOpened.current = hasOpened.current || Boolean(site);
    if (!hasOpened.current) {
        return null;
    }
    return (
        <React.Suspense fallback={null}>
            <ChangeSitePlanDialog />
        </React.Suspense>
    );
}
